import * as R from 'ramda'
import React from 'react'
import { getParticipants } from '../api/async/participants/index'
import { getUserMe } from '../api/async/users/index'
import {
  MobileParticipantCard,
  ParticipantCard
} from '../components/ParticipantCard/index'
import { formatDateTime } from '../utils/index'

class Participants extends React.Component {
  state = {}
  componentDidMount() {
    getParticipants({ id: this.props.match.params.id }).then(res =>
      this.setState({ participant: res.data[0] })
    )
    getUserMe().then(res => this.setState({ user: res.data }))
  }

  render() {
    const { participant } = this.state
    return (
      <div className="ui one column stackable centered grid">
        {participant && (
          <div className="column">
            <ParticipantCard
              bib={participant.bib}
              is_paid={participant.is_paid}
              payment={participant.payment[0]}
              participantId={participant.id}
              featureImage={R.path(
                ['race_detail', 'race', 'feature_image'],
                participant
              )}
              title={R.path(['race_detail', 'race', 'title'], participant)}
              registerDate={`${formatDateTime(
                R.path(
                  ['race_detail', 'race', 'start_register_time'],
                  participant
                )
              )} - ${formatDateTime(
                R.path(
                  ['race_detail', 'race', 'end_register_time'],
                  participant
                )
              )}`}
              raceDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], participant)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'end_time'], participant)
              )}`}
              submitDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], participant)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'last_submit_time'], participant)
              )}`}
            />
            <MobileParticipantCard
              bib={participant.bib}
              is_paid={participant.is_paid}
              payment={participant.payment[0]}
              participantId={participant.id}
              featureImage={R.path(
                ['race_detail', 'race', 'feature_image'],
                participant
              )}
              title={R.path(['race_detail', 'race', 'title'], participant)}
              registerDate={`${formatDateTime(
                R.path(
                  ['race_detail', 'race', 'start_register_time'],
                  participant
                )
              )} - ${formatDateTime(
                R.path(
                  ['race_detail', 'race', 'end_register_time'],
                  participant
                )
              )}`}
              raceDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], participant)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'end_time'], participant)
              )}`}
              submitDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], participant)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'last_submit_time'], participant)
              )}`}
            />
          </div>
        )}
      </div>
    )
  }
}

export default Participants



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Participant.js